export default {
  title: 'ブラックリスト管理',
  tip: 'ブラックリストに登録されたメンバーはいかなるメンバーアクティビティにも参加できなくなります。ブラックリストメンバーはここで管理できます。',
  columns: {
    id: 'ID',
    nickname: 'メンバーニックネーム',
    level: 'メンバーレベル',
    country: '所在国',
    email: 'メール',
    phone: '電話番号',
    wechat: 'WeChat',
    registerTime: '登録時間',
  },
  actions: {
    remove: 'ブラックリスト解除',
  },
  removeConfirm: {
    title: 'このユーザーをブラックリストから解除しますか？',
    tip: 'ブラックリストを解除すると、このユーザーはすべてのアクティビティに正常に参加できるようになります。',
  },
};
